import React from 'react';
import { Currencies } from '../../../../Util/currencies';
import { useAppSelector } from '../../../../../Redux/Store/hooks';

// Define the props interface for the component
interface CartOrderTotalProps {
  totalPrice: number;
  priceCurrency: number;
}

export function CartOrderTotal({
  totalPrice,
  priceCurrency,
} : CartOrderTotalProps) : JSX.Element {

  // From the store, get the strings
  const strings = useAppSelector((state) => {
    return state.TextsReducer.strings;
  })!;

  const itemPriceWithCurrency = Currencies.formatPrice(totalPrice, priceCurrency);
  return (
    <div
      className="cartOrderTotal"
      style={
        {
          marginTop: '20px',
          borderBottom: '1px solid #EEEEEE',
          borderTop: '2px solid #444444',
          display: 'flex',
          width: '100%',
          padding: '5px',
        }
      }
    >
      <div className="cartOrderFiller" style={{ textAlign: 'left', width: '50%' }} />
      <div
        className="cartItemPriceAndQuantity"
        style={
          {
            width: '50%',
            textAlign: 'right',
            justifyContent: 'right',
          }
        }
      >
        <h3
          className="cartOrderPrice"
          style={
            {
              width: '100%',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              marginLeft: '5px',
              textAlign: 'right',
              justifyContent: 'right',
            }
          }
        >
          {`${strings.ORDER_TOTAL_LABEL} = ${itemPriceWithCurrency}`}
        </h3>
      </div>
    </div>
  );
}

export default CartOrderTotal;
